// @ts-check
// TABS AS DESTINATIONS (plan-6 §6b.1 item 4).
//
// A screen with more than one presentation — a list vs. a board, a table vs.
// a chart — already declares its `views` array for ViewSwitcher (§6f.3). This
// file names those same views again so the palette can jump to one directly,
// rather than only to the screen it lives on.
//
//   {
//     to: '/deals',                             // the screen's own route
//     label: t('nav.deals'),                     // the screen's own label
//     app: 'academy', screen: 'deals',          // offered when canScreen(app, screen, 'view');
//                                               // an entry with no `screen` is always offered
//     views: [
//       { key: 'list', label: t('deals.tabList') },
//       { key: 'board', label: t('deals.tabBoard') },
//     ],
//   }
//
// The palette builds each destination as `to + '?view=' + key` — exactly the
// URL ViewSwitcher itself would put a click on.
//
// ONLY A SCREEN AT A FIXED ROUTE BELONGS HERE. `CohortDetail` and
// `PersonDetail` both use ViewSwitcher, but at `/cohorts/:id` and
// `/people/:id` — a tab there is meaningless without knowing which record, so
// neither is a palette destination and neither is listed below.
//
// AN EMPTY LIST COSTS NOTHING, same as paletteSources: no screen here has a
// second, fixed-route presentation yet, so this is a door left open rather
// than a feature switched on.
export const paletteTabs = [];
